import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Currency } from '@depay/local-currency';

import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';

const EditUser = (props) => {
    const {user} = props;
    

    const [countries, setCountries] = useState('');
    const { isLoading: isloadingCountries, refetch: getCountries } = useQuery(
        "countries",
        async () => {
          return await apiClient.get("/api/countries");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setCountries(res.data.countries);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      const [myCurrency, setMyCurrency] = useState('USD');
      console.log(myCurrency);
    const setSelectedCurrency = (id) =>{
        if (countries !== '') {
            countries.forEach(country => {
                if (country.id === id) {
                    setMyCurrency(country.currency_code)
                }
                
            });
        }
    }

    const dispatch = useDispatch();
    const initialLogin = {

        name: user.name,
        email: user.email,
        password: user.pass_copy,
        phone: user.phone,
        country: user.country,
        currency: myCurrency,
        verification_status: user.verification_status,
        error_message: user.error_message,
        error_type: user.error_type,
        account_status: user.account_status,

    }
   
    const [error, setErros] = useState('');
    
    const [EditUserForm, setEditUserForm] = useState(initialLogin);
    const appMode = useSelector((state) => state.mode.mode);
    const redirectTo = useSelector((state) => state.redirect.redirect);

    const navigate = useNavigate();

    const onChange = (e) =>
    setEditUserForm({ ...EditUserForm, [e.target.name]: e.target.value });

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(
        
        async () => {
          return await apiClient.post(`/api/edit-user`, {
            user_id: user.id,
            name: EditUserForm.name,
            email: EditUserForm.email,
            password: EditUserForm.password,
            phone: EditUserForm.phone,
            country: EditUserForm.country,
            currency: myCurrency,
            verification_status: EditUserForm.verification_status,
            error_message: EditUserForm.error_message,
            error_type: EditUserForm.error_type,
            account_status: EditUserForm.account_status,
            
            

          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);

          },
          onError: (err) => {   
            if (err.response?.data.length) {
                let myerror = err.response?.data || err;         
            setErros(myerror.errors)             
            }else{
                let errorMessage = err.response?.data.message || err ;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);

            }  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);   
          },
        }
      );
      const onSubmit = async() =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postLogin();
        // await apiClient.get("/sanctum/csrf-cookie").then(() => {
          
        // })
      } 

      useEffect(() => {
        getCountries();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
        <Grid container px={0} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '1px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <Typography mt={4} sx={{ fontWeight: 'bold', fontSize: 24, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                        Edit User
                    </Typography>
                    <Typography  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        Fill the form below to edit {user.name}'s account
                    </Typography>


                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="Full Name">Full Name</InputLabel>
                            {(error !== '' && error.name) ?
                            <OutlinedInput
                            error
                            onChange={onChange}
                            id="name"
                            name="name"
                            defaultValue={user.name}
                            type={'text'}
                            label="Full Name"
                            helperText={error.name}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="name"
                            name="name"
                            defaultValue={user.name}
                            type={'text'}
                            label="Full Name"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.name}
                            </Typography>
                            
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            {(error !== '' && error.email) ?

                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="email"
                            type={'email'}
                            name="email"
                            defaultValue={user.email}
                            label="Email"
                            helperText={error.email}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="email"
                            type={'email'}
                            name="email"
                            defaultValue={user.email}
                            label="Email"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.email}
                            </Typography>
                            
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="password">Password</InputLabel>
                            <OutlinedInput
                            onChange={onChange}
                            id="password"
                            name="password"
                            defaultValue={user.pass_copy}
                            type={'text'}
                            label="Password"
                            />
                        </FormControl>

                        {(countries !== '' && countries.length > 0 )&&
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="country">Select Country</InputLabel>
                        {(error !== '' && error.country) ?
                        <Select
                        error
                        onChange={onChange}
                        labelId="country"
                        id="country"
                        name="country"
                        defaultValue={user.country}
                        label={`Select Country`}
                        helperText={error.country}
                        >
                        <MenuItem selected value=''>
                            Select Country
                        </MenuItem> 
                        {countries.map(country =>(
                            <MenuItem value={country.name}>
                            {country.name} </MenuItem>
                        ))}             
                        
                    </Select>
                        :
                        <Select
                            onChange={onChange}
                            labelId="country"
                            name="country"
                            defaultValue={user.country}
                            id="country"
                            label={`Select Country`}
                            >
                            <MenuItem selected value="">
                                Select Country
                            </MenuItem>              
                            {countries.map(country =>(
                            <MenuItem value={country.name}>
                                
                                {country.name} </MenuItem>
                            ))} 
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.country}
                        </Typography>
                    </FormControl>
                        }

                    {/* {(countries !== '' && countries.length > 0 )&&
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="currency">Select currency</InputLabel>
                        {(error !== '' && error.currency) ?
                        <Select
                        error
                        onChange={(e)=>setSelectedCurrency(e.target.value)}
                        labelId="currency"
                        id="currency"
                        name="currency"
                        defaultValue={user.currency}
                        label={`Select currency`}
                        helperText={error.currency}
                        >
                        <MenuItem selected value=''>
                            Select currency
                        </MenuItem> 
                        {countries.map(currency =>(
                            <MenuItem value={currency.id}>
                                <img style={{height: "15px", width: "20px", marginRight: '4px'}} alt="Menubar Icon" src={currency.flag} />
                                {currency.currency_code} ({currency.name})
                            </MenuItem>
                        ))}             
                        
                    </Select>
                        :
                        <Select
                            onChange={(e)=>setSelectedCurrency(e.target.value)}
                            labelId="currency"
                            name="currency"
                            defaultValue={user.currency}
                            id="currency"
                            label={`Select currency`}
                            >
                            <MenuItem selected value="">
                                Select currency
                            </MenuItem>              
                            {countries.map(currency =>(
                            <MenuItem value={currency.id}>
                                <img style={{height: "15px", width: "20px", marginRight: '4px'}} alt="Menubar Icon" src={currency.flag} />
                                {currency.currency_code} ({currency.name})
                             </MenuItem>
                            ))} 
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.currency}
                        </Typography>
                        <Typography color='error'>
                            Current Value is {user.currency}
                        </Typography>
                    </FormControl>
                        } */}

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="verification_status">Select Verification Status</InputLabel>
                        {(error !== '' && error.verification_status) ?
                        <Select
                        error
                        onChange={onChange}
                        labelId="verification_status"
                        id="verification_status"
                        name="verification_status"
                        defaultValue={user.verification_status}
                        label={`Select Verification Status`}
                        helperText={error.verification_status}
                        >
                        <MenuItem selected value=''>
                            Select Verification Status
                        </MenuItem> 
                        <MenuItem value="verified">
                        Verified   
                        </MenuItem>
                        <MenuItem value="unverified">
                        Unverified  
                        </MenuItem>             
                       
                        
                    </Select>
                        :
                        <Select
                            onChange={onChange}
                            labelId="verification_status"
                            name="verification_status"
                            defaultValue={user.verification_status}
                            id="verification_status"
                            label={`Select Verification Status`}
                            >
                            <MenuItem selected value="">
                                Select Verification Status
                            </MenuItem>              
                            <MenuItem value="verified">
                            Verified   
                            </MenuItem>
                            <MenuItem value="unverified">
                            Unverified  
                            </MenuItem>   
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.verification_status}
                        </Typography>
                    </FormControl>



                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="phone">Phone</InputLabel>
                            {(error !== '' && error.phone) ? 
                            <OutlinedInput
                            error
                            onChange={onChange}
                            id="phone"
                            name="phone"
                            defaultValue={user.phone}
                            type={'tel'}
                            label="Phone"
                            helperText={error.phone}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="phone"
                            name="phone"
                            defaultValue={user.phone}
                            type={'tel'}
                            label="Phone"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.phone}
                            </Typography>
                        </FormControl>

                        
                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="error_type">Select Error Type</InputLabel>
                        {(error !== '' && error.error_type) ?
                        <Select
                        error
                        onChange={onChange}
                        labelId="error_type"
                        id="error_type"
                        name="error_type"
                        defaultValue={user.error_type}
                        label={`Select Error Type`}
                        helperText={error.error_type}
                        >
                        <MenuItem selected value=''>
                            Select Error Type
                        </MenuItem>

                        <MenuItem value="withdrawal">
                        withdrawal   
                        </MenuItem>
                        <MenuItem value="clear">
                        clear error   
                        </MenuItem>
                       
                        
                    </Select>
                        :
                        <Select
                            onChange={onChange}
                            labelId="error_type"
                            name="error_type"
                            defaultValue={user.error_type}
                            id="error_type"
                            label={`Select Error Type`}
                            >
                            <MenuItem selected value="">
                                Select Error Type
                            </MenuItem>              
                            <MenuItem value="withdrawal">
                        withdrawal   
                        </MenuItem>
                        <MenuItem value="clear">
                        clear error   
                        </MenuItem>
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.error_type}
                        </Typography>
                    </FormControl>

                    
<FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
<InputLabel htmlFor="account_status">Select Account Status</InputLabel>
{(error !== '' && error.account_status) ?
<Select
error
onChange={onChange}
labelId="account_status"
id="account_status"
name="account_status"
defaultValue={user.account_status}
label={`Select Account Status`}
helperText={error.account_status}
>
<MenuItem selected value=''>
    Select Account Status
</MenuItem>

<MenuItem value="active">
Active   
</MenuItem>

<MenuItem value="inactive">
Inactive   
</MenuItem>
<MenuItem value="suspended">
Suspended   
</MenuItem>


</Select>
:
<Select
    onChange={onChange}
    labelId="account_status"
    name="account_status"
    defaultValue={user.account_status}
    id="account_status"
    label={`Select Account Status`}
    >
    <MenuItem selected value="">
        Select Account Status
    </MenuItem>              
    <MenuItem value="active">
Active   
</MenuItem>

<MenuItem value="inactive">
Inactive   
</MenuItem>
<MenuItem value="suspended">
Suspended   
</MenuItem>
</Select>
}
<Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
{error !== '' && error.account_status}
</Typography>
</FormControl>

                    
                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="Error Message">Error Message</InputLabel>
                            {(error !== '' && error.error_message) ?
                            <OutlinedInput
                            error
                            onChange={onChange}  
                            multiline
                            minRows={4}                          
                            id="error_message"
                            name="error_message"
                            defaultValue={user.error_message}
                            type={'text'}
                            label="Error Message"
                            helperText={error.error_message}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            multiline
                            minRows={4}  
                            id="error_message"
                            name="error_message"
                            defaultValue={user.error_message}
                            type={'text'}
                            label="Error Message"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.error_message}
                            </Typography>
                            
                        </FormControl>
                    </CardContent>                    
                    <CardActions>
                        <Button onClick={onSubmit} fullWidth={true} size="large" color="primary" variant="contained"> {isSendingRequest? 'Editing...' : 'Edit Account'}</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    </div>
  )
}

export default EditUser
